import { Box, Button } from "@mui/material";
import React from "react";

type EditDetailsFormActionsProps = {
  setIsEditing: (value: boolean) => void;
  disabledSubmit?: boolean;
};

export const EditDetailsFormActions: React.FC<EditDetailsFormActionsProps> = ({
  setIsEditing,
  disabledSubmit = false,
}) => {
  return (
    <Box display="flex" justifyContent="flex-end" columnGap={2.5} py={10}>
      <Button
        size="medium"
        variant="outlined"
        onClick={() => {
          setIsEditing(false);
        }}
      >
        Cancel
      </Button>
      <Button
        size="medium"
        variant="contained"
        type="submit"
        disabled={disabledSubmit}
      >
        Save Changes
      </Button>
    </Box>
  );
};
